import { REDUX_SECTION_TO_DOMAIN } from 'modules/redux/constants'

/**
 * Gets the domain name from the given section.
 * e.g. `store` => `products`
 * @param  {string} section
 * @returns {string}
 */
function getDomainPathFromSectionReduxUtil (section) {
  return REDUX_SECTION_TO_DOMAIN[section]
}

export default getDomainPathFromSectionReduxUtil
